import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import { message } from 'ant-design-vue';
import VueApexCharts from 'vue3-apexcharts';

export const createAppInstance = (AppComponent, router, additionalPlugins = []) => {
  const app = createApp(AppComponent);

  app.use(Antd);
  app.use(router);
  app.use(VueApexCharts);

  additionalPlugins.forEach((plugin) => {
    app.use(plugin);
  });

  app.config.globalProperties.$message = message;

  return app;
};
